import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import './TankLink.scss';
import { NotFound } from 'app/agriculture/routes/NotFound';
import { useParams } from 'react-router-dom';
import { isExpectedEntityRootPath } from 'app/agriculture/routes/Tanks/TankLink/isExpectedEntityRootPath';
import { TankUnlinkForm } from 'app/agriculture/routes/Tanks/TankLink/components/TankUnlinkForm';
import { useMemo } from 'react';
import { Device } from 'app/agriculture/queries/devices/types/Device';
import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';

export function TankUnlink() {
    // get all tanks and tank sensors
    const tanks = useEntities('Tank');
    const tankSensors = useDevicesByType('Level Monitor');

    const { entityRootPath, id: paramsId } = useParams();

    const tankSensorsByInfrastructureId = useMemo(() => {
        const map = new Map<string, Device>();
        for (const [, tankSensor] of tankSensors) {
            const { infrastructureId } = tankSensor;
            if (infrastructureId != null) {
                map.set(infrastructureId, tankSensor);
            }
        }
        return map;
    }, [tankSensors]);

    if (paramsId == null || !isExpectedEntityRootPath(entityRootPath)) {
        return <NotFound />;
    }

    const device =
        entityRootPath === 'devices'
            ? tankSensors.get(paramsId)
            : tankSensorsByInfrastructureId.get(paramsId);

    const tank =
        entityRootPath === 'tanks'
            ? tanks.get(paramsId)
            : device?.infrastructureId == null
              ? null
              : tanks.get(device.infrastructureId);

    if (tank == null || device == null) {
        console.error('could not find tank or device');
        return <NotFound />;
    }

    return <TankUnlinkForm tank={tank} device={device} entityRootPath={entityRootPath} />;
}
